























import { Component, Prop, Vue } from "vue-property-decorator";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faAdjust, faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import { applyGwernMode, GWERN_MODE_KEY } from "@/utilities";

type Mode = "auto" | "light" | "dark";

// gwern.net's mode switcher: auto follows the device, light and dark pin the look.
@Component
export default class GwernDecor extends Vue {
  @Prop({ required: true }) readonly place!: string;

  modes: { value: Mode; label: string; title: string; icon: IconDefinition }[] =
    [
      {
        value: "auto",
        label: "Auto",
        title: "Auto: follow the device's light or dark setting",
        icon: faAdjust,
      },
      { value: "light", label: "Light", title: "Light mode", icon: faSun },
      { value: "dark", label: "Dark", title: "Dark mode", icon: faMoon },
    ];

  mode: Mode = "auto";

  created(): void {
    try {
      const saved = localStorage.getItem(GWERN_MODE_KEY);
      if (saved === "light" || saved === "dark") {
        this.mode = saved;
      }
    } catch (e) {
      // Storage can be blocked; stay on auto
    }
  }

  setMode(mode: Mode): void {
    this.mode = mode;
    try {
      if (mode === "auto") {
        localStorage.removeItem(GWERN_MODE_KEY);
      } else {
        localStorage.setItem(GWERN_MODE_KEY, mode);
      }
    } catch (e) {
      // Without storage the choice lasts until the page reloads
      document.documentElement.setAttribute("data-gwern-mode", mode);
      return;
    }
    applyGwernMode("gwern");
  }
}
